import React from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import {
  generateOptionsBasedOnRole,
  getResellerNotificationCount,
  getResponsableNotificationCount,
} from "../../Utils/savUtils";
import VerticalPoints from "../Common/VerticalPoints/VerticalPoints";
import { TicketProblemPicker } from "./NewTicketSav/TicketProblemPicker";
import TicketStatusTag from "./NewTicketSav/TicketStatusTag";
import { openRightModal } from "../../REDUX/actions/rightModal";
import UpdateTicketSav from "./UpdateTicketSavAdmin/UpdateTicketSav";
import { handleValue } from "../../Utils";
import { useTranslation } from "react-i18next";

const SavCard = ({
  name,
  id,
  date,
  deliveryDate,
  refClient,
  status,
  problem,
  users,
  relaunchDate,
  reseller,
  notifications,
}) => {
  const { t } = useTranslation("common");
  const { user, userRole } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();

  const responsable = users.find((user) => user.userRole === 1);

  const responsableNotificationCount =
    getResponsableNotificationCount(notifications);
  const resellerNotificationCount = getResellerNotificationCount(notifications);

  const attachmentNotificationCount =
    notifications?.filter(
      (notification) =>
        !notification?.attributes?.comment?.data &&
        notification?.attributes?.type === "attachment",
    )?.length || 0;

  const ticketNotificationCount =
    notifications?.filter(
      (notification) =>
        !notification?.attributes?.comment?.data &&
        notification?.attributes?.type === "status",
    )?.length > 0
      ? (attachmentNotificationCount || 0) + 1
      : attachmentNotificationCount;

  const totalNotificationCount =
    ticketNotificationCount +
    (user?.attributes?.userRole === 0 ? resellerNotificationCount : 0);

  const userOptions = generateOptionsBasedOnRole(
    userRole,
    id,
    dispatch,
    t,
    user?.id,
    status,
  );

  const handleUpdate = () => {
    dispatch(openRightModal(<UpdateTicketSav id={id} />));
  };

  return (
    <div
      className="row px-4 py-4 d-flex justify-content-between align-items-center w-100 m-0 pointer"
      style={{ backgroundColor: notifications?.length > 0 ? "#f7fafe" : "" }}
      onClick={handleUpdate}
    >
      <span className="text-softBlue normal f14 col-1">
        {name ? `${name} - ${id}` : id}
      </span>
      <span className="text-brightGrey normal f14 col-1">
        {moment(date).format("DD-MM-YYYY")}
      </span>
      {user?.attributes?.userRole !== 0 && (
        <>
          <div className="d-flex flex-column gap-1 col-1">
            <div className="d-flex align-items-center gap-2">
              <span className="text-brightGrey normal f14 ellipsis-text">
                {handleValue(reseller?.attributes?.name)}
              </span>

              {resellerNotificationCount > 0 && (
                <span
                  className="d-flex align-items-center justify-content-center align-middle f12 text-white sBold"
                  style={{
                    borderRadius:
                      resellerNotificationCount < 10 ? "50%" : "20px",
                    backgroundColor: "#a3c5ed",
                    width: resellerNotificationCount < 10 ? "20px" : "35px",
                    minWidth: resellerNotificationCount < 10 ? "20px" : "35px",
                    height: resellerNotificationCount < 10 ? "20px" : "auto",
                    minHeight: resellerNotificationCount < 10 ? "20px" : "auto",
                    lineHeight: "normal",
                  }}
                >
                  <>
                    {resellerNotificationCount < 10
                      ? resellerNotificationCount
                      : `+${Math.min(resellerNotificationCount, 99)}`}
                  </>
                </span>
              )}
            </div>
          </div>
          {user?.attributes?.userRole === 1 && (
            <span className="text-brightGrey normal f14 col-1 ellipsis-text d-flex gap-2 align-items-center">
              {responsable
                ? responsable.firstName + " " + responsable.lastName
                : "-"}
              {responsableNotificationCount > 0 && (
                <span
                  className="d-flex align-items-center justify-content-center align-middle f12 text-white sBold"
                  style={{
                    borderRadius:
                      responsableNotificationCount < 10 ? "50%" : "20px",
                    backgroundColor: "#a3c5ed",
                    width: responsableNotificationCount < 10 ? "20px" : "35px",
                    minWidth:
                      responsableNotificationCount < 10 ? "20px" : "35px",
                    height: responsableNotificationCount < 10 ? "20px" : "auto",
                    minHeight:
                      responsableNotificationCount < 10 ? "20px" : "auto",
                    lineHeight: "normal",
                  }}
                >
                  <>
                    {responsableNotificationCount < 10
                      ? responsableNotificationCount
                      : `+${Math.min(responsableNotificationCount, 99)}`}
                  </>
                </span>
              )}
            </span>
          )}
        </>
      )}

      <span className="text-brightGrey normal f14 col-1">
        {deliveryDate ? moment(deliveryDate).format("DD-MM-YYYY") : "-"}
      </span>
      {user?.attributes?.userRole === 0 && (
        <span className="text-brightGrey normal f14 col-1">
          {refClient ?? "-"}
        </span>
      )}
      <div className="col-1 ">
        <TicketStatusTag status={status} />
      </div>
      <span className="text-brightGrey normal f14 col-1 ">
        {TicketProblemPicker(problem)}
      </span>
      {user?.attributes?.userRole === 1 && (
        <span className="text-brightGrey normal f14 col-1">
          {relaunchDate && status !== 2
            ? moment(relaunchDate)?.format("DD-MM-YYYY")
            : "-"}
        </span>
      )}
      <span className="text-brightGrey normal f14 col-1 ">
        {totalNotificationCount > 0 && (
          <span
            className="d-flex align-items-center justify-content-center align-middle f12 text-white sBold ms-2"
            style={{
              borderRadius: totalNotificationCount < 10 ? "50%" : "20px",
              backgroundColor: "#a3c5ed",
              width: totalNotificationCount < 10 ? "20px" : "35px",
              minWidth: totalNotificationCount < 10 ? "20px" : "35px",
              height: totalNotificationCount < 10 ? "20px" : "auto",
              minHeight: totalNotificationCount < 10 ? "20px" : "auto",
              lineHeight: "normal",
            }}
          >
            {totalNotificationCount}
          </span>
        )}
      </span>
      <div className="text-brightGrey textEnd normal f14 col-1 d-flex justify-content-end">
        <VerticalPoints showLeft options={userOptions} />
      </div>
    </div>
  );
};

export default SavCard;
